export default "__VITE_ASSET__DJao4JT5__"